import { TaskTypesTypes, TaskTypesAction, TaskType } from '../types';

export function getTaskTypesList(taskTypes: TaskType[]): TaskTypesAction<{ taskTypes: TaskType[] }> {
    return {
        type: TaskTypesTypes.GET_TASK_TYPES_LIST,
        payload: { taskTypes },
    };
}

export function requestGetTaskTypesList() {
    return {
        type: TaskTypesTypes.REQUEST_GET_TASK_TYPES_LIST,
    };
}
